import React from 'react';
import { processEntityLink } from '../../modules/moduleregistry';
import Icon from '../icon';

export default class EntityLink extends React.PureComponent {
	constructor() {
		super();
		this.go = this.go.bind(this);
	}

	go() {
		processEntityLink(this.props.entityName, this.props.entityId);
	}

	render() {
		return <Icon
			name="entityLink"
			className="ps-input entityLink"
			active
			disabled={!this.props.entityId || !this.props.entityName}
			onMouseDown={this.go}
			hint={this.props.hint}
		/>;
	}
}
